import {
  makeBatchDisableUserPage,
  makeCompanyDetailPage,
  makeInvoiceDetailPage,
  makeInvoicePage,
  makePartnerDetailPage
} from '@/main/factories/pages'
import { ValidAccountState } from '@/presentation/contexts/auth/account-provider'
import useAccount from '@/presentation/hooks/auth/use-account'
import { useQueryClient } from 'react-query'
import { RouteObject } from 'react-router-dom'
import CompanyDetailLoader from '../loaders/internal-company-manager/company-detail-loader'
import InternalCompanyManagerSimpleImageLoader from '../loaders/internal-company-manager/internal-company-manager-simple-image-loader'
import InvoiceDetailLoader from '../loaders/internal-company-manager/invoice-detail-loader'
import InvoiceListLoader from '../loaders/internal-company-manager/invoice-list-loader'
import PartnerDetailLoader from '../loaders/partner/partner-detail-loader'
import PathConstants from '../path-contants'
import LoggedLayout from '@/presentation/components/ui/layout/logged-layout'

const {
  INTERNAL_COMPANY_MANAGER_USER_BATCH_DISABLE,
  INTERNAL_COMPANY_MANAGER_INVOICE,
  INTERNAL_COMPANY_MANAGER_INVOICE_DETAIL,
  INTERNAL_COMPANY_MANAGER_COMPANY_DETAIL,
  INTERNAL_COMPANY_MANAGER_PARTNER_DETAIL
} = PathConstants.Routes

const BuildInternalCompanyManagerRoutes = (): RouteObject[] => {
  const [account] = useAccount() as ValidAccountState
  const queryClient = useQueryClient()
  return [
    {
      element: (
        <LoggedLayout
          navMenu="internalCompanyManager"
          footerVariant="compact"
          enableSearch={false}
        />
      ),
      children: [
        {
          path: INTERNAL_COMPANY_MANAGER_USER_BATCH_DISABLE.value,
          element: makeBatchDisableUserPage(),
          loader: new InternalCompanyManagerSimpleImageLoader(
            account,
            import('@images/file-processed.svg'),
            queryClient
          ).loader
        },
        {
          path: INTERNAL_COMPANY_MANAGER_INVOICE.value,
          element: makeInvoicePage(),
          loader: new InvoiceListLoader(account, queryClient).loader
        },
        {
          path: INTERNAL_COMPANY_MANAGER_INVOICE_DETAIL.value,
          element: makeInvoiceDetailPage(),
          loader: new InvoiceDetailLoader(account, queryClient).loader
        },
        {
          path: INTERNAL_COMPANY_MANAGER_COMPANY_DETAIL.value,
          element: makeCompanyDetailPage(),
          loader: new CompanyDetailLoader(account, queryClient).loader
        },
        {
          path: INTERNAL_COMPANY_MANAGER_PARTNER_DETAIL.value,
          element: makePartnerDetailPage(),
          loader: new PartnerDetailLoader(account, queryClient).loader
        }
      ]
    }
  ]
}

export default BuildInternalCompanyManagerRoutes
